// extracted by mini-css-extract-plugin
export default {"tooltip":"OnlineBookingNotEnableTooltip_tooltip__5aBAX"};